import { createContext, useContext } from 'react';

import type { SlotRegistry } from './slot-registry.js';
export type {
  ContentSlotConfig,
  DetailsSlotConfig,
  HeaderSlotConfig,
  SidebarSlotConfig,
} from './slot-config.js';

/** @internal */
export interface PageLayoutPortalContextValue {
  hosts: {
    header: HTMLDivElement;
    sidebar: HTMLDivElement;
    content: HTMLDivElement;
    details: HTMLDivElement;
  };
  registry: SlotRegistry;
}

/** @internal */
export const PageLayoutPortalContext =
  createContext<PageLayoutPortalContextValue | null>(null);

/** @internal */
export function usePageLayoutPortalContext(): PageLayoutPortalContextValue {
  const ctx = useContext(PageLayoutPortalContext);
  if (ctx === null) {
    throw new Error(
      'PageLayout slot components (Header, Sidebar, Content, Details) must be rendered inside a <PageLayout>.',
    );
  }
  return ctx;
}
